module.exports = __webpack_public_path__ + "img/airsynth.3dec2d1b.png";